<h2>Button Variants</h2>

<div class="button-grid">
	<div class="button-column">
		<span class="label">Primary</span>
		<app-button
			label="Iniciar sesión"
			variant="primary"
			(onClick)="onButtonClick('Primary')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Texto', variant: 'primary'})" />

		<app-button
			label="Iniciar sesión"
			variant="primary"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Texto', variant: 'primary', disabled: true})" />

		<app-button
			label="Con icono"
			icon="MoveRight"
			variant="primary"
			(onClick)="onButtonClick('Primary with icon')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Texto', icon: 'MoveRight', variant: 'primary'})" />
	</div>

	<div class="button-column">
		<span class="label">Secondary</span>
		<app-button
			label="Iniciar sesión"
			variant="secondary"
			(onClick)="onButtonClick('Secondary')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Texto', variant: 'secondary'})" />

		<app-button
			label="Iniciar sesión"
			variant="secondary"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Texto', variant: 'secondary', disabled: true})" />

		<app-button
			label="Con icono"
			icon="Download"
			variant="secondary"
			(onClick)="onButtonClick('Secondary with icon')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Texto', icon: 'Download', variant: 'secondary'})" />
	</div>

	<div class="button-column">
		<span class="label">Tertiary</span>
		<app-button
			label="Iniciar sesión"
			variant="tertiary"
			(onClick)="onButtonClick('Tertiary')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Texto', variant: 'tertiary'})" />
		<app-button
			label="Iniciar sesión"
			variant="tertiary"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Texto', variant: 'tertiary', disabled: true})" />
	</div>

	<div class="button-column">
		<span class="label">Link</span>
		<app-button
			label="Ver perfil"
			variant="link"
			routerLink="/profile"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Texto', variant: 'link', routerLink: '/ruta'})" />
		<app-button
			label="Ver perfil"
			variant="link"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Texto', variant: 'link', disabled: true})" />
		<p class="note">Para navegación con routerLink</p>
	</div>

	<div class="button-column">
		<span class="label">Ghost</span>
		<app-button
			label="Crear cliente"
			icon="Plus"
			variant="ghost"
			(onClick)="onButtonClick('Ghost')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Crear cliente', icon: 'Plus', variant: 'ghost'})" />
		<app-button
			label="Crear cliente"
			icon="Plus"
			variant="ghost"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Crear cliente', icon: 'Plus', variant: 'ghost', disabled: true})" />
		<p class="note">Completamente transparente con icono + texto</p>
	</div>
</div>

<h2>Button Sizes</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px)</span>
		<app-button
			label="Button Text"
			variant="primary"
			size="large"
			(onClick)="onButtonClick('Large')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Text', variant: 'primary', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px)</span>
		<app-button
			label="Button Text"
			variant="primary"
			size="medium"
			(onClick)="onButtonClick('Medium')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Text', variant: 'primary', size: 'medium'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px)</span>
		<app-button
			label="Button Text"
			variant="primary"
			size="small"
			(onClick)="onButtonClick('Small')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Text', variant: 'primary', size: 'small'})" />
	</div>

	<div class="size-column">
		<span class="label">XSmall (32px)</span>
		<app-button
			label="Button Text"
			variant="primary"
			size="xsmall"
			(onClick)="onButtonClick('XSmall')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Text', variant: 'primary', size: 'xsmall'})" />
	</div>
</div>

<h2>Icon Buttons</h2>

<div class="button-grid">
	<div class="button-column">
		<span class="label">Icon Only</span>
		<app-button
			icon="move-right"
			variant="icon-only"
			(onClick)="onButtonClick('Icon')"
		/>
		<app-ui-code-block [code]="generateCode({icon: 'MoveRight', variant: 'icon-only'})" />
		<app-button
			icon="move-right"
			variant="icon-only"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({icon: 'MoveRight', variant: 'icon-only', disabled: true})" />
	</div>

	<div class="button-column">
		<span class="label">Icon Only Secondary</span>
		<app-button
			icon="Download"
			variant="icon-only-secondary"
			(onClick)="onButtonClick('Icon Only Secondary')"
		/>
		<app-ui-code-block [code]="generateCode({icon: 'Download', variant: 'icon-only-secondary'})" />
		<app-button
			icon="Download"
			variant="icon-only-secondary"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({icon: 'Download', variant: 'icon-only-secondary', disabled: true})" />
	</div>

	<div class="button-column">
		<span class="label">Icon Ghost</span>
		<app-button
			icon="Bell"
			variant="icon-ghost"
			(onClick)="onButtonClick('Icon Ghost')"
		/>
		<app-ui-code-block [code]="generateCode({icon: 'Bell', variant: 'icon-ghost'})" />
		<app-button
			icon="Bell"
			variant="icon-ghost"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({icon: 'Bell', variant: 'icon-ghost', disabled: true})" />
	</div>
</div>

<h2>Icon Button Sizes</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px / Icon 32px)</span>
		<app-button
			icon="move-right"
			variant="icon-only"
			size="large"
			(onClick)="onButtonClick('Icon Large')"
		/>
		<app-ui-code-block [code]="generateCode({icon: 'MoveRight', variant: 'icon-only', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px / Icon 32px)</span>
		<app-button
			icon="move-right"
			variant="icon-only"
			size="medium"
			(onClick)="onButtonClick('Icon Medium')"
		/>
		<app-ui-code-block [code]="generateCode({icon: 'MoveRight', variant: 'icon-only', size: 'medium'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px / Icon 24px)</span>
		<app-button
			icon="move-right"
			variant="icon-only"
			size="small"
			(onClick)="onButtonClick('Icon Small')"
		/>
		<app-ui-code-block [code]="generateCode({icon: 'MoveRight', variant: 'icon-only', size: 'small'})" />
	</div>

	<div class="size-column">
		<span class="label">XSmall (32px / Icon 16px)</span>
		<app-button
			icon="move-right"
			variant="icon-only"
			size="xsmall"
			(onClick)="onButtonClick('Icon XSmall')"
		/>
		<app-ui-code-block [code]="generateCode({icon: 'MoveRight', variant: 'icon-only', size: 'xsmall'})" />
	</div>
</div>

<h2>Button Types (for Forms)</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Button (default)</span>
		<app-button
			label="Normal Button"
			variant="primary"
			type="button"
			(onClick)="onButtonClick('Button Type')"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Text', variant: 'primary', type: 'button'})" />
		<p class="note">No hace nada especial con el form</p>
	</div>

	<div class="size-column">
		<span class="label">Submit</span>
		<app-button
			label="Enviar Form"
			variant="primary"
			type="submit"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Text', variant: 'primary', type: 'submit'})" />
		<p class="note">Envía el formulario automáticamente</p>
	</div>

	<div class="size-column">
		<span class="label">Reset</span>
		<app-button
			label="Limpiar Form"
			variant="secondary"
			type="reset"
		/>
		<app-ui-code-block [code]="generateCode({label: 'Text', variant: 'secondary', type: 'reset'})" />
		<p class="note">Resetea todos los campos del form</p>
	</div>
</div>
